export default __webpack_public_path__ + "static/media/projection-handler.89bb9851.svg";